// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StorageCollection$SmartcutsMacros = require("./StorageCollection.bs.js");

function t_encode(v) {
  return Image$SmartcutsMacros.ImageWithId.t__encode(v);
}

function t_decode(v) {
  return Image$SmartcutsMacros.ImageWithId.t__decode(v);
}

function idGet(param) {
  return Image$SmartcutsMacros.idAsString(param.id);
}

var include = StorageCollection$SmartcutsMacros.Make({
      t_encode: t_encode,
      t_decode: t_decode,
      name: "images",
      idGet: idGet
    });

var findById = include.findById;

function rehydrateScreenshot(screenshot) {
  if (typeof screenshot === "number") {
    return Promise.resolve(screenshot);
  }
  switch (screenshot.TAG | 0) {
    case /* Image */0 :
        var id = screenshot._0;
        return Curry._1(findById, Image$SmartcutsMacros.idAsString(id)).then(function (maybeImage) {
                    return Promise.resolve(OptionUtils$SmartcutsMacros.withDefault(screenshot, OptionUtils$SmartcutsMacros.map(maybeImage, (function (param) {
                                          return {
                                                  TAG: /* Image */0,
                                                  _0: id,
                                                  _1: param.image
                                                };
                                        }))));
                  });
    case /* SavingToCloud */1 :
        var id$1 = screenshot._0;
        return Curry._1(findById, Image$SmartcutsMacros.idAsString(id$1)).then(function (maybeImage) {
                    return Promise.resolve(OptionUtils$SmartcutsMacros.withDefault(screenshot, OptionUtils$SmartcutsMacros.map(maybeImage, (function (param) {
                                          return {
                                                  TAG: /* SavingToCloud */1,
                                                  _0: id$1,
                                                  _1: param.image
                                                };
                                        }))));
                  });
    case /* Cloud */2 :
        return Promise.resolve(screenshot);
    
  }
}

var all = include.all;

var saveMany = include.saveMany;

var updateById = include.updateById;

var upsert = include.upsert;

var deleteByIds = include.deleteByIds;

var migrate = include.migrate;

exports.all = all;
exports.findById = findById;
exports.saveMany = saveMany;
exports.updateById = updateById;
exports.upsert = upsert;
exports.deleteByIds = deleteByIds;
exports.migrate = migrate;
exports.rehydrateScreenshot = rehydrateScreenshot;
/* include Not a pure module */
